import React, { useState, useEffect } from "react";
import { message, Spin } from "antd";

import { useAdmin } from "context/adminContext";

import AccountDetail from "../partials/accountDetail";

const AccountRemain = () => {
  const [loading, setLoading] = useState(false);
  const { accounts } = useAdmin();

  return (
    <div className="p-6">
      <h2 className="text-xl font-semibold text-[#32B7C2] mb-4">
        💰 Дансны үлдэгдлийн тойм
      </h2>
      <Spin spinning={loading}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {accounts &&
            accounts
              .filter((e) => e.type !== "xPay")
              .map((account) => {
                return <AccountDetail account={account} />;
              })}
        </div>
      </Spin>
    </div>
  );
};

export default AccountRemain;
